import React, { useEffect, useRef, useState } from "react";

import WhatsAppWidget from "react-whatsapp-chat-widget";
import "react-whatsapp-chat-widget/index.css";
import styled from "styled-components";
import img from "../images/sup.png";

const WhatsApp = () => {
  const [size, setSize] = useState(80);
  const [whinSize, setWinSize] = useState(window.innerWidth);

  useEffect(() => {
    console.log(size);
    if (window.innerWidth < 900) {
      setSize(65);
    } else {
      setSize(80);
    }
  }, [whinSize]);

  useEffect(() => {
    function handleResize() {
      setWinSize(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <WhatsAppWidget
      phoneNo="+5511917721058"
      position="right"
      widgetWidth="300px"
      widgetWidthMobile="260px"
      autoOpen={false}
      messageBox={true}
      messageBoxTxt=""
      iconSize={size}
      iconColor="#ffffff"
      iconBgColor="#72bc35"
      headerIcon={img}
      headerIconColor="pink"
      headerTxtColor="white"
      headerBgColor="#272727"
      headerTitle="Renato Mendes"
      headerCaption="Online"
      bodyBgColor="#E3DCD5"
      chatPersonName="Suporte"
      chatMessage={
        <Chat>
          <br />
          Olá 👋 <br />
          <br /> Como eu posso te ajudar?
        </Chat>
      }
      footerBgColor="#A5BC35"
      placeholder="Escreva uma mensagem..."
      btnBgColor="#272727"
      btnTxt="Enviar Mensagem"
      btnTxtColor="white"
    />
  );
};
export default WhatsApp;

const Chat = styled.div`
  font-size: 13px;
  height: 58px;
`;
